export const ORDER_TYPE_GLOBAL = "A";
export const ORDER_TYPE_PARTIAL = "B";
